<p-badge [value]="value" [severity]="severity" [style]="{ 'white-space': 'nowrap' }"></p-badge>